import { ReactElement } from 'react'
import { AdminLayout } from '@/components/AdminLayout'
import { Link } from '@/components/elements/Link'
import { Cinema } from '@/src/types'
import { getCinemas } from '@/src/cinemas'
import { useAllCinemasQuery, useGetProjectionQuery } from '../../types/types'

export async function getServerSideProps(context) {
  const cinemas = getCinemas()
  return {
    props: {},
  }
}

export default function AdminHome(): ReactElement {
  const { data, loading, error } = useAllCinemasQuery()

  return (
    <AdminLayout>
      <table className="w-full">
        <thead>
          <tr>
            <th className="text-left">Nom</th>
            <th className="text-left">City</th>
            <th className="text-left">Private Url</th>
          </tr>
        </thead>
        <tbody>
          {data?.cinemas.map((cinema: Cinema) => (
            <tr key={cinema.id}>
              <td className="py-2">
                <Link href={`/admin/cinemes/${cinema.id}`}>{cinema.name}</Link>
              </td>
              <td className="text-left">{cinema.city}</td>
              <td className="text-left">
                <a
                  className="text-orange underline"
                  href={`/cinemes/${cinema.id}/bookings/?token=${cinema.token}`}
                >
                  /cinemes/{cinema.id}/bookings/?token={cinema.token}
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </AdminLayout>
  )
}
